import React, { Component } from 'react';
import styles from './banner.css';
import image_bg from '../../assets/images/background.jpg';
import logo_gtx from '../../assets/images/logo_gtx_red.png';
import gtx from '../../assets/images/gtx_printer.png';
import gtx_retina from '../../assets/images/gtx_printer@2x.png';
import icon_down from '../../assets/icons/icon_down.svg';
import jump from 'jump.js'
import Lang from '../../i18n'
import {
  withRouter
} from 'react-router-dom'

class Banner extends Component {

  scrollToCalculator(){
    jump('.calculator');
  }

  render() {
    return (
      <div className={styles.banner + " lazyload"} data-bgset={image_bg}>
        <div>
          <div className={styles.content}>
            <img src={logo_gtx} alt="" />
            <h2 className={styles.text}>The X factor for your garment printing business</h2>
          </div>
          <img className={styles.printer} src={gtx} srcSet={gtx + " 1x , " + gtx_retina + " 2x"} alt=""/>
          <span className={styles.scroll} onClick={this.scrollToCalculator}>
            <p>{Lang.translate("banner:calculate", this.props.location.pathname)}</p>
            <img className={styles.scrollImage} src={icon_down} alt="" />
          </span>
        </div>
        
      </div>
    );
  }
}

export default withRouter(Banner);



// WEBPACK FOOTER //
// ./src/components/banner/banner.js